/**
 * @generated SignedSource<<1f9627f69c66de35624324c90dfb9a52>>
 * @relayHash a6e57bb74ecf6413dc5ad2bc0f0f3495
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/572.0.0-2026-08-13T16:08:00.849Z/buildItemsGridDataMoreQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type buildItemsGridDataMoreQuery$variables = {
  abTestList?: ReadonlyArray<string | null> | null;
  bestsellingDesignsCount: number;
  excellentValuesCount: number;
  homepageId: string;
  isTrade: boolean;
  mostSavedCount: number;
  mostSavedPageStartOffset: number;
  priceBookName: string;
  userType: string;
};
export type buildItemsGridDataMoreQuery$data = {
  readonly viewer: {
    readonly bestsellingDesigns: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly excellentValues: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly homepage: {
      readonly modules: ReadonlyArray<{
        readonly items?: ReadonlyArray<{
          readonly imageUrl: string | null;
          readonly linkData: {
            readonly path: string | null;
          };
          readonly title: string | null;
        } | null> | null;
        readonly type?: string | null;
      } | null> | null;
    } | null;
    readonly mostSavedItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly serviceId: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_item" | "hpSharedItemsGridTracking_item">;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemsGridContent_viewer">;
  };
};
export type buildItemsGridDataMoreQuery = {
  response: buildItemsGridDataMoreQuery$data;
  variables: buildItemsGridDataMoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": ([]/*:: as any*/),
  "kind": "LocalArgument",
  "name": "abTestList"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bestsellingDesignsCount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excellentValuesCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "homepageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostSavedCount"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mostSavedPageStartOffset"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userType"
},
v9 = [
  {
    "kind": "Variable",
    "name": "abTestList",
    "variableName": "abTestList"
  },
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "homepageId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "EditorialItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v10/*:: as any*/),
        (v11/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            (v12/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialModule",
  "abstractKey": null
},
v14 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "mostSavedCount"
  },
  {
    "kind": "Literal",
    "name": "module",
    "value": "MOST_SAVED_MODULE"
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pageStartOffset",
    "variableName": "mostSavedPageStartOffset"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v19 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v20 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchTreandingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Item",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v15/*:: as any*/),
          {
            "kind": "InlineDataFragmentSpread",
            "name": "hpSharedItemsGridTracking_item",
            "selections": [
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/)
            ],
            "args": null,
            "argumentDefinitions": ([]/*:: as any*/)
          },
          {
            "args": [
              (v19/*:: as any*/),
              (v20/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "HpSharedItemsGridContent_item"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v22 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "excellentValuesCount"
  },
  {
    "kind": "Literal",
    "name": "module",
    "value": "EXCELLENT_VALUES_MODULE"
  }
],
v23 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "bestsellingDesignsCount"
  },
  {
    "kind": "Literal",
    "name": "module",
    "value": "BEST_SELLING_MODULE"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchTreandingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Item",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v15/*:: as any*/),
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          {
            "alias": "productPhotos",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1
              }
            ],
            "concreteType": "ItemPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "masterOrZoomPath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "smallPath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemPhotoVersion",
                "kind": "LinkedField",
                "name": "versions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webPath",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v24/*:: as any*/)
            ],
            "storageKey": "photos(limit:1)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "localizedPdpUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ItemMeasurement",
            "kind": "LinkedField",
            "name": "measurement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "addLabel",
                    "value": true
                  },
                  {
                    "kind": "Literal",
                    "name": "fields",
                    "value": [
                      "height",
                      "width",
                      "depth",
                      "diameter",
                      "length"
                    ]
                  },
                  {
                    "kind": "Literal",
                    "name": "separator",
                    "value": " "
                  }
                ],
                "concreteType": "ItemDisplayMeasurementType",
                "kind": "LinkedField",
                "name": "display",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unit",
                    "storageKey": null
                  },
                  (v25/*:: as any*/)
                ],
                "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ItemSize",
                "kind": "LinkedField",
                "name": "size",
                "plural": false,
                "selections": [
                  (v25/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArt",
            "storageKey": null
          },
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ItemClassification",
            "kind": "LinkedField",
            "name": "classification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creationDate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ItemCreator",
            "kind": "LinkedField",
            "name": "creators",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Creator",
                "kind": "LinkedField",
                "name": "creator",
                "plural": false,
                "selections": [
                  (v26/*:: as any*/),
                  (v24/*:: as any*/)
                ],
                "storageKey": null
              },
              (v24/*:: as any*/)
            ],
            "storageKey": null
          },
          (v27/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMultiSku",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRingItem",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VariableAttribute",
            "kind": "LinkedField",
            "name": "variableAttributes",
            "plural": true,
            "selections": [
              (v15/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VariableAttributeSortType",
                "kind": "LinkedField",
                "name": "variableAttributeData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SwatchSort",
                    "kind": "LinkedField",
                    "name": "swatchSort",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Swatch",
                        "kind": "LinkedField",
                        "name": "swatch",
                        "plural": false,
                        "selections": [
                          (v15/*:: as any*/),
                          (v26/*:: as any*/),
                          (v10/*:: as any*/),
                          (v24/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v24/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v19/*:: as any*/),
              {
                "kind": "Literal",
                "name": "page",
                "value": "searchAndBrowse"
              },
              (v20/*:: as any*/)
            ],
            "concreteType": "ItemDisplayPriceType",
            "kind": "LinkedField",
            "name": "displayPrice",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "kind": "LinkedField",
                "name": "convertedAmountList",
                "plural": true,
                "selections": (v28/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "kind": "LinkedField",
                "name": "originalConvertedAmountList",
                "plural": true,
                "selections": (v28/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quantityDisplay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "percentageOff",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "textType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amountType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showPriceLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "showPriceVariability",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vertical",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ShipmentQuote",
            "kind": "LinkedField",
            "name": "shipmentQuotes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isComplimentary",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isCalculated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "kind": "LinkedField",
                "name": "totalAmount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmounts",
                    "kind": "LinkedField",
                    "name": "convertedAmounts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "USD",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentServiceMethod",
                "kind": "LinkedField",
                "name": "serviceMethod",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Region",
                    "kind": "LinkedField",
                    "name": "region",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "regionName",
                        "storageKey": null
                      },
                      (v24/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*:: as any*/)
                ],
                "storageKey": null
              },
              (v24/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "QuickViewDisplayType",
            "kind": "LinkedField",
            "name": "quickViewDisplay",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QuickViewParagraph",
                "kind": "LinkedField",
                "name": "paragraphs",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  },
                  {
                    "alias": "mobileText",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "formatType",
                        "value": "MOBILE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": "text(formatType:\"MOBILE\")"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuickViewCreator",
                "kind": "LinkedField",
                "name": "creators",
                "plural": true,
                "selections": [
                  (v26/*:: as any*/),
                  (v27/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuickViewCategorySegments",
                "kind": "LinkedField",
                "name": "paragraphAttributeNames",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "period",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "origin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "style",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "periodPrefix",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v24/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "buildItemsGridDataMoreQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HpSharedItemsGridContent_viewer"
          },
          {
            "alias": null,
            "args": (v9/*:: as any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "mostSavedItems",
            "args": (v14/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": (v21/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "excellentValues",
            "args": (v22/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": (v21/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "bestsellingDesigns",
            "args": (v23/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": (v21/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*:: as any*/),
      (v4/*:: as any*/),
      (v3/*:: as any*/),
      (v8/*:: as any*/),
      (v0/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "buildItemsGridDataMoreQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*:: as any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "mostSavedItems",
            "args": (v14/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": (v29/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "excellentValues",
            "args": (v22/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": (v29/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "bestsellingDesigns",
            "args": (v23/*:: as any*/),
            "concreteType": "ItemSearchTreandingConnection",
            "kind": "LinkedField",
            "name": "itemSearchTrending",
            "plural": false,
            "selections": (v29/*:: as any*/),
            "storageKey": null
          },
          (v24/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/572.0.0-2026-08-13T16:08:00.849Z/buildItemsGridDataMoreQuery",
    "metadata": {},
    "name": "buildItemsGridDataMoreQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c977f3eba0e3b21a0f608e17840b6435";

export default node;
